/**
 * 이미지 축소 헬퍼 — 브라우저 canvas 로 업로드 전에 축소.
 * 백엔드 Pillow 미사용 정책(확정): File → canvas(최대 긴변 maxSize) → JPEG Blob.
 *
 * 사용 예:
 *   const blob = await resizeImage(file);            // 최대 900px, 품질 0.82
 *   const fd = new FormData(); fd.append('file', blob, 'meal.jpg');
 */
export async function resizeImage(
  file: File,
  maxSize = 900,
  quality = 0.82,
): Promise<Blob> {
  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error('파일을 읽지 못했습니다'));
    reader.readAsDataURL(file);
  });

  const img = await new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('이미지를 불러오지 못했습니다'));
    image.src = dataUrl;
  });

  const longEdge = Math.max(img.width, img.height);
  const scale = longEdge > maxSize ? maxSize / longEdge : 1;
  const w = Math.round(img.width * scale);
  const h = Math.round(img.height * scale);

  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('canvas 를 생성하지 못했습니다');
  ctx.drawImage(img, 0, 0, w, h);

  const blob = await new Promise<Blob | null>((resolve) =>
    canvas.toBlob((b) => resolve(b), 'image/jpeg', quality),
  );
  if (!blob) throw new Error('이미지 변환에 실패했습니다');
  return blob;
}
